// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b8986ce8","278":"212d103c","768":"c222efab","781":"c227618f","962":"8f23701c"}[chunkId] + ".chunk.js";
};